import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const menuSlotRecipe = defineSlotRecipe({
  slots: ['trigger'],
  base: {
    trigger: defineStyle({
      transitionProperty: 'common',
      transitionDuration: 'normal',
      _hover: { bg: 'bg.hover' },
      _active: { bg: 'bg.active' },
      _expanded: { bg: 'bg.active' },
    }),
  },
});

export default menuSlotRecipe;
